// import React from "react";
// import OpenCalendly from "./sub-comps/OpenCalendly";

// function ContactUs() {
//   return (
//     <div className="">
//       <section class="mt-[90px] mb-32">
//         <div
//           id="map"
//           class="relative h-[400px] overflow-hidden bg-cover bg-[50%] bg-no-repeat"
//         >
//           <iframe
//             src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3306.937875373406!2d-6.837072024178406!3d34.01980557316932!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xda76bf879493ae3%3A0x747f12605f8426e1!2sEvoMarket%20Agency!5e0!3m2!1sfr!2sma!4v1731754832682!5m2!1sfr!2sma"
//             referrerpolicy="no-referrer-when-downgrade"
//             width="100%"
//             height="480"
//             allowfullscreen=""
//             loading="lazy"
//           ></iframe>
//         </div>

//         <section class="body-font relative px-10">
//           <div class="container mt-10 md:mx-auto lg:mx-auto px-5 py-24 bg-customAqua600 text-gray-400 rounded-lg">
//             <div class="mb-12 flex w-full flex-col text-center">
//               <h1 class="title-font mb-4 text-2xl font-medium text-white sm:text-3xl">
//                 Contactez Nous
//               </h1>
//               <p class="mx-auto text-base leading-relaxed lg:w-2/3">
//                 N'hésitez pas à nous contacter !
//               </p>
//             </div>

//             <div class="mx-auto md:w-2/3 lg:w-1/2">
//               <div class="-m-2 flex flex-wrap">
//                 <div class="w-1/2 p-2">
//                   <div class="relative">
//                     <input
//                       type="text"
//                       id="name"
//                       name="name"
//                       class="peer w-full rounded border border-gray-700 bg-gray-800 bg-opacity-40 py-1 px-3 text-base leading-8 text-gray-100 placeholder-transparent outline-none transition-colors duration-200 ease-in-out focus:border-indigo-500  focus:ring-2 "
//                       placeholder="Name"
//                     />
//                     <label
//                       for="name"
//                       class="absolute left-3 -top-6 bg-transparent text-sm leading-7 text-indigo-500 transition-all peer-placeholder-shown:left-3 peer-placeholder-shown:top-2 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-500 peer-focus:left-3 peer-focus:-top-6 peer-focus:text-sm peer-focus:text-indigo-500"
//                     >
//                       Nom Et Prénom
//                     </label>
//                   </div>
//                 </div>
//                 <div class="w-1/2 p-2">
//                   <div class="relative">
//                     <input
//                       type="email"
//                       id="email"
//                       name="email"
//                       class="peer w-full rounded border border-gray-700 bg-gray-800 bg-opacity-40 py-1 px-3 text-base leading-8 text-gray-100 placeholder-transparent outline-none transition-colors duration-200 ease-in-out focus:border-indigo-500 focus:bg-gray-900 focus:ring-2 focus:ring-indigo-900"
//                       placeholder="Email"
//                     />
//                     <label
//                       for="email"
//                       class="absolute left-3 -top-6 bg-transparent text-sm leading-7 text-indigo-500 transition-all peer-placeholder-shown:left-3 peer-placeholder-shown:top-2  peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-500 peer-focus:left-3 peer-focus:-top-6 peer-focus:text-sm peer-focus:text-indigo-500"
//                     >
//                       Email
//                     </label>
//                   </div>
//                 </div>
//                 <div class="mt-4 w-full p-2">
//                   <div class="relative">
//                     <textarea
//                       id="message"
//                       name="message"
//                       class="peer h-32 w-full resize-none rounded border border-gray-700 bg-gray-800 bg-opacity-40 py-1 px-3 text-base leading-6 text-gray-100 placeholder-transparent outline-none transition-colors duration-200 ease-in-out focus:border-indigo-500 focus:bg-gray-900 focus:ring-2 focus:ring-indigo-900"
//                       placeholder="Message"
//                     ></textarea>
//                     <label
//                       for="message"
//                       class="absolute left-3 -top-6 bg-transparent text-sm leading-7 text-indigo-500 transition-all peer-placeholder-shown:left-3 peer-placeholder-shown:top-2  peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-500 peer-focus:left-3 peer-focus:-top-6 peer-focus:text-sm peer-focus:text-indigo-500"
//                     >
//                       Message
//                     </label>
//                   </div>
//                 </div>
//                 <div class="w-full p-2">
//                   <button class="mx-auto flex rounded border-0 bg-customAqua100 py-2 px-8 text-lg text-white hover:bg-indigo-600 focus:outline-none">
//                     {/* Envoyer */}
//                     <OpenCalendly />
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>
//       </section>
//     </div>
//   );
// }

// export default ContactUs;

import React from "react";
// import BtnRounded from "../components/sub-comps/BtnRounded";
// import OpenCalendly from "../components/sub-comps/OpenCalendly";
import Booking from "./sub-comps/Booking";
import WhatsAppButton from "./WhtsappButton";
import ReviewsWidget from "./sub-comps/MoreReviews";
import Reviews from "./sub-comps/Reviews";
import { useLocation } from "react-router-dom";
function ContactPage() {
  const location = useLocation()
  return (
    <div className="min-h-screen bg-gray-50   pt-[150px]">
      {/* Container */}
      <div className="max-w-7xl mx-auto py-12 px-4">
        {/* Title */}
        <h1 className="text-6xl font-thin text-customAqua600 text-center mb-12">
          Contactez Nous
        </h1>

        {/* Upper Section */}
        <div className="flex flex-col lg:flex-row gap-6 lg:gap-12 ">
          {/* Left Div: Map, Photo, and Address */}
          <div className="w-full lg:w-2/3 space-y-6 bg-gray-50  border-4 border-white border-solid p-4 shadow-xl rounded-lg ">
            {/* Map */}
            <div className="h-[300px] w-full rounded-lg overflow-hidden shadow-md">
              <iframe
                className="w-full h-full"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d826.3567146302859!2d-6.849968460499236!3d34.004445593883716!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xda76c8977a247a7%3A0xf94986fef6964edf!2sRue%20Aguelmane%20Sidi%20Ali%2C%20Rabat!5e1!3m2!1sfr!2sma!4v1733477480975!5m2!1sfr!2sma"
                allowFullScreen=""
                loading="lazy"
                title="Google Map"
              ></iframe>
            </div>

            {/* Address */}
            <div className="">
              <h2 className="text-lg font-light text-gray-700">Téléphone:</h2>
              <p className="text-gray-600 font-extralight">05 30 35 60 20</p>
              <p className="text-gray-600 font-extralight">06 63 39 15 00</p>
            </div>
            {/* Address */}
            <div className="">
              <h2 className="text-lg font-light text-gray-700">Address:</h2>
              <p className="text-gray-600 font-extralight">
                Rue Aguelmane Sidi Ali, Imm.18, 1er étage, Appt 4, AGDAL
              </p>
            </div>
          </div>

          {/* Right Div: Working Hours */}
          <div className="w-full lg:w-1/3 space-y-6  bg-customAqua100/10 border-4 border-white border-solid p-4 shadow-xl rounded-lg">
            <h2 className="text-xl font-extralight text-customAqua600">
              Heures de travail
            </h2>
            <table className="w-full text-gray-700">
              <tbody>
                <tr>
                  <td className="py-2">Lundi</td>
                  <td className="py-2">9:00 - 18:00</td>
                </tr>
                <tr>
                  <td className="py-2">Mardi</td>
                  <td className="py-2">9:00 - 18:00</td>
                </tr>
                <tr>
                  <td className="py-2">Mercredi</td>
                  <td className="py-2">9:00 - 18:00</td>
                </tr>
                <tr>
                  <td className="py-2">Jeudi</td>
                  <td className="py-2">9:00 - 18:00</td>
                </tr>
                <tr>
                  <td className="py-2">Vendredi</td>
                  <td className="py-2">9:00 - 18:00</td>
                </tr>
                <tr>
                  <td className="py-2">Samedi</td>
                  <td className="py-2">10:00 - 14:00</td>
                </tr>
                <tr>
                  <td className="py-2">Dimanche</td>
                  <td className="py-2">Fermé</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Bottom Section */}
        {/* <div className="mt-12">
          <div className="bg-white rounded-lg shadow-lg p-8">
            <h2 className="text-xl font-bold text-customAqua600 mb-4">
              Faire une réservation
            </h2>
            <p className="text-gray-600 mb-6">
              Réservez votre rendez-vous en ligne facilement. Contactez-nous
              pour toute assistance. Réservez maintenant pour des soins
              personnalisés !
            </p>
            <p className="text-gray-600 mb-6">
              Veuillez envoyer un courriel à:{" "}
              <a
                href="mailto:info@dentalcare.com.au"
                className="text-customAqua600 underline"
              >
                contact@drcherkaouiabir.ma
              </a>{" "}
              ou appelez le (212) 6-10-20-34-11 si vous avez besoin d'aide.
            </p>
            <p className="text-gray-600 mb-6">
              Pour réserver, il suffit de cliquer sur le bouton ci-dessous.
            </p>

            <BtnRounded>
              <OpenCalendly />
            </BtnRounded>
          </div>
        </div> */}
      </div>
      {/* Call to Action Section */}
      {/* <div className="flex  flex-col  lg:flex-row md:flex-row  items-center justify-around mt-12 text-center bg-customAqua100/20 py-20">
        <div className="mb-8 lg:mb-0 md:mb-0">
          <h3 className="text-2xl font-thin text-customAqua600">
            Prêt à prendre rendez-vous ?
          </h3>
          <p className="text-customAqua600 font-light mt-4">
            Contactez-nous dès maintenant pour prendre rendez-vous et bénéficier
            des meilleurs soins.
          </p>
        </div>
        <BtnRounded>
          <OpenCalendly />
        </BtnRounded>
      </div> */}
      <Reviews/>
      <Booking />
      <WhatsAppButton/>
    </div>
  );
}

export default ContactPage;
